"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlignableWidget = void 0;
var GetTraitConfig_1 = require("./GetTraitConfig");
var isAlignableWidget = function (token) {
    return !!(0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "alignable" });
};
exports.isAlignableWidget = isAlignableWidget;
